import React from 'react'
import styles from './EditPage.module.scss'
import { FormDeposit } from 'components/FormDeposit/FormDeposit'
import { FormEdit } from './FormEdit/FormEdit'
import { Icon } from 'components/Icon/Icon'
import { THEME_COLORS } from './FormEdit/consts'
import { EditNavBar } from './EditNavBar/EditNavBar'
import { MOCK_USER_DATA } from 'components/FormDeposit/const'
import { useAppSelector } from 'redux/hooks'

type Props = {
    children?: React.ReactNode,
    onClose: () => void,
}

export function EditPage(props: Props) {
    const { theme } = useAppSelector((state) => state.root)
    const [isDataChanged, setIsDataChanged] = React.useState(false)
    const [data, setData] = React.useState(MOCK_USER_DATA)

    function handleSubmit() {
        setIsDataChanged(false)
        // handle save data
    }

    function handleDiscard() {
        setIsDataChanged(false)
        // handle discard data
    }

    function handleChange(data) {
        setIsDataChanged(true)
        setData(data)
    }

    return (
        <div className={styles['wrapper']}>
            <EditNavBar
                onClose={props.onClose}
                onSubmit={handleSubmit}
                onDiscard={handleDiscard}
                isDataChanged={isDataChanged}
            />
            <div className={styles['edit-content']}>
                <div className={styles['scroll']}>
                    <FormEdit
                        theme={theme}
                        title='Edit page'
                        onChange={handleChange}
                        data={data}
                    />
                </div>
            </div>
            <div
                className={styles['preview']}
                style={{ backgroundColor: THEME_COLORS[theme] }}
            >
                <div className={styles['preview__logo']}>
                    <Icon name='preview' />
                    <span>Preview</span>
                </div>
                <FormDeposit data={data} />
            </div>
        </div>
    )
}
